
    var riot = require('riot')
    //src: starling/src/tags/gallery.html
riot.tag2('gallery',
  '<header if="{current}" class="gallery_header {!showChrome && \'gallery_header--out\'}" onclick="{stopPropagation}"> <div class="gallery_data"> <h2 if="{current.getTitle()}" class="gallery_title">{current.getTitle().toString()}</h2> <p if="{current.getSummary().toString()}" class="gallery_description">{current.getSummary().toString()}</p> </div> <button class="Button Button--Pill Button--Even Button--Dark Button--Large" onclick="{closeGallery}" style="--button-padding: 15px;"> <svg class="Button__Icon"> <use xlink:href="#close-icon"></use> </svg> </button> </header> <loading if="{isLoading}"></loading> <div if="{current}" ref="main" class="gallery"> <button if="{nodes.length > 1}" class=" gallery_nav gallery_nav--prev {!showChrome && \'gallery_nav--out\'} Button Button--Pill Button--Even Button--Dark Button--Large " onclick="{prev}"> <svg class="Button__Icon"> <use xlink:href="#chevron-left-icon"></use> </svg> </button> <img if="{isImage(current)}" ref="image" class="gallery_image {isLoading && \'gallery_image--loading\'}" riot-src="{current.attachedFile.file_url}" alt="{current.getTitle().toString()}" onclick="{toggleZoom}" onload="{handleImageLoad}"> <video if="{isVideo(current)}" ref="video" class="gallery_video" controls="true" riot-src="{current.attachedFile.file_url}" onclick="{playVideo}" onmousemove="{showControls}" onmouseout="{hideControls}" onloadedmetadata="{handleVideoLoad}"></video> <object if="{isPDF(current)}" ref="pdf" class="gallery_pdf" type="application/pdf" data="{current.attachedFile.file_url}" onclick="{stopPropagation}"></object> <button if="{nodes.length > 1}" class=" gallery_nav gallery_nav--next {!showChrome && \'gallery_nav--out\'} Button Button--Pill Button--Even Button--Dark Button--Large " onclick="{next}"> <svg class="Button__Icon"> <use xlink:href="#chevron-right-icon"></use> </svg> </button> </div>',
  '',
  'show="{isVisible}" class="gallery_overlay {isLoading && \'gallery_overlay--loading\'}" onclick="{closeGallery}" onwheel="{stopPropagation}"', function(opts) {
'use strict';

var _this = this;

var _lodash = require('lodash.flattendeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _util = require('lib/util');

var _appUi = require('lib/app-ui');

var _delayHandler = require('lib/delay-handler');

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas;

this.isVisible = false;
this.isZoomedIn = false;
this.showChrome = true;
this.index = 0;
this.nodes = [];
this.current = null;

this.stopPropagation = function (event) {
  return event && event.stopPropagation();
};

this.isImage = function (_ref) {
  var attachedFile = _ref.attachedFile;
  return attachedFile.file_type.startsWith('image');
};

this.isVideo = function (_ref2) {
  var attachedFile = _ref2.attachedFile;
  return (0, _util.canPlayVideo)(attachedFile.file_type);
};

this.isPDF = function (_ref3) {
  var attachedFile = _ref3.attachedFile;
  return attachedFile.file_type === 'application/pdf';
};

this.closeGallery = function () {
  _this.isVisible = false;
  _this.isZoomedIn = false;
  _this.showChrome = true;
  _this.index = 0;
  _this.nodes = [];
  _this.current = null;

  _delayHandler.delayHandler.clearDelayFor('gallery-edge-hover');

  _this.update();
};

this.isViewable = function (_ref4) {
  var attachedFile = _ref4.attachedFile;
  return attachedFile && (_this.isImage({ attachedFile: attachedFile }) || _this.isVideo({ attachedFile: attachedFile }) || _this.isPDF({ attachedFile: attachedFile }));
};

this.mapChildren = function (node) {
  var children = node.children();
  if (!children.length) return node;
  return children.map(_this.mapChildren).concat(node);
};

this.getNodes = function () {
  var elements = (0, _lodash2.default)(_store_instance2.default.getNodesArray().filter(function (node) {
    return node.isTopLevel();
  }).map(_this.mapChildren)).filter(_this.isViewable);

  _appUi.appUI.sortElementsByPosition({ elements: elements });

  return elements;
};

this.summon = function (_ref5) {
  var node = _ref5.node;

  canvas.hidePopups();
  var nodes = _this.nodes = _this.getNodes();
  _this.isHideChromeInitialized = false;
  _this.show({
    index: nodes.findIndex(function (element) {
      return element === node;
    })
  });
};

this.displayChrome = function () {
  _this.showChrome = true;
  _this.update();
};

this.hideChrome = function () {
  _this.showChrome = false;
  _this.update();
};

this.handleLoad = function () {
  _this.update();

  if (!_this.isHideChromeInitialized) {
    _this.isHideChromeInitialized = true;
    _delayHandler.delayHandler.initializeDelay({
      action: 'gallery-edge-hover',
      id: 'gallery',
      delay: 1500,
      callback: _this.hideChrome
    });
  }
};

this.handleVideoLoad = function () {
  setTimeout(function () {
    if (!_this.loadingSrc || _this.refs && _this.refs.video && _this.refs.video.src === _this.loadingSrc) {
      _this.loadingSrc = null;
      _this.isLoading = false;
      _this.handleLoad();
    }
  }, 2000);
};

this.handlePdfLoad = function () {
  if (!_this.loadingSrc || _this.refs && _this.refs.pdf && _this.refs.pdf.data === _this.loadingSrc) {
    _this.handleLoad();
  }
};

this.handleImageLoad = function () {
  if (!_this.loadingSrc || _this.refs && _this.refs.image && _this.refs.image.src === _this.loadingSrc) {
    _this.loadingSrc = null;
    _this.isLoading = false;
    _this.checkIfZoomable();
    _this.handleLoad();
  }
};

this.show = function (_ref6) {
  var index = _ref6.index;

  _this.isVisible = true;
  _this.index = index;
  _this.current = _this.nodes[index];

  var mediaSrc = _this.current.attachedFile.file_url;
  _this.loadingSrc = mediaSrc;

  // update to get the img/object/video into the dom
  _this.update();

  var _refs = _this.refs,
      video = _refs.video,
      image = _refs.image,
      pdf = _refs.pdf;

  if (image) {
    image.src = mediaSrc;
    if (!image.complete) {
      _this.isLoading = true;
    } else {
      _this.handleImageLoad();
    }
  } else if (video) {
    video.currentTime = 0;
    _this.isLoading = true;
  } else if (pdf) {
    _this.isLoading = false;
  }

  // update to reflect loading state and set media src
  _this.update();
};

this.isFirst = function () {
  return _this.index === 0;
};

this.isLast = function () {
  return _this.index === _this.nodes.length - 1;
};

this.prev = function (event) {
  _this.stopPropagation(event);

  if (!_this.isFirst()) {
    _this.show({ index: _this.index - 1 });
  } else {
    _this.show({ index: _this.nodes.length - 1 });
  }
};

this.next = function (event) {
  _this.stopPropagation(event);

  if (!_this.isLast()) {
    _this.show({ index: _this.index + 1 });
  } else {
    _this.show({ index: 0 });
  }
};

this.toggleZoom = function (event) {
  _this.stopPropagation(event);

  if (!_this.isZoomable) return;

  _this.isZoomedIn = !_this.isZoomedIn;
  _this.checkIfZoomable();
};

this.checkIfZoomable = function () {
  if (!_this.current) return;

  var _refs2 = _this.refs,
      main = _refs2.main,
      image = _refs2.image;

  if (!image) return;

  var naturalWidth = image.naturalWidth,
      naturalHeight = image.naturalHeight,
      classList = image.classList;
  var clientHeight = main.clientHeight,
      clientWidth = main.clientWidth;

  var imageAspectRatio = naturalWidth / naturalHeight;
  // 192 is the horizontal padding of the gallery (96 * 2)
  // 32 is the vertical padding of the gallery (16 * 2)
  var galleryAspectRatio = (clientWidth - 192) / (clientHeight - 32);

  if (naturalHeight > clientHeight && imageAspectRatio < galleryAspectRatio) {
    _this.isZoomable = true;
  } else {
    _this.isZoomable = false;
  }

  if (_this.isZoomable) {
    if (!_this.isZoomedIn) {
      classList.add('gallery_image--zoomedOut');
      classList.remove('gallery_image--zoomedIn');
    } else {
      classList.remove('gallery_image--zoomedOut');
      classList.add('gallery_image--zoomedIn');
    }
  } else {
    classList.remove('gallery_image--zoomedIn');
    classList.remove('gallery_image--zoomedOut');
  }
};

this.playVideo = function (event) {
  var video = _this.refs.video;

  _this.stopPropagation(event);

  if (video.paused) {
    _this.hideControls();
    video.play();
  } else {
    video.pause();
    _this.showControls();
  }
};

this.showControls = function () {
  return _this.refs.video.setAttribute('controls', 'controls');
};

this.hideControls = function () {
  return _this.refs.video.removeAttribute('controls');
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('gallery')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/gallery.html
// module id = 768
// module chunks = 0